export function deleteCookie(name: string, path: string, domain: string) {
  const _path = path || '/';
  const _domain = domain || document.domain;

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${_path}; domain=${_domain};`;
}

export function getCookie(name: string) {
  const _value = `; ${document.cookie}`;
  const _parts = _value.split(`; ${name}=`);

  if (_parts.length === 2) {
    const cookieValue = _parts.pop();

    if (cookieValue) {
      return cookieValue.split(';').shift();
    }
  }

  return null;
}
